import { CmmFileType } from '../../../shared/types/cmmConfig.ts';
import { readFileAsString } from '../../utils/readFile.ts';
import { csvStringToTable } from './csvStringToTable.ts';
import { xlsxFileToTable } from './xlsxFileToTable.ts';


export async function fileToTable(
    file: File,
    fileType: CmmFileType,
): Promise<string[][]> {
    if (fileType === 'csv') {
        const fileText = await readFileAsString(file, 'ISO-8859-1');
        return csvStringToTable(fileText);
    } else if (fileType === 'excel') {
        return await xlsxFileToTable(file);
    } else {
        throw new Error(`Unsupported file type: ${fileType}`);
    }
}
